import { observable, action, computed } from 'mobx'
import BaseStore from './baseStore'
import storage from '@/utils/storage'

export interface ICatalogueItem {
  type: string
  name: string
  sn: string
}

export interface IPanel {
  sn?: string
  [key: string]: any
}

export interface IAccount {
  userName: string
  password: string
}

class BackendStore extends BaseStore {
  constructor() {
    super()
    this.init()
  }

  async init() {
    const account: IAccount = await storage.getItem(storage.KEYS.backendAccount)
    const currentPanel: IPanel = await storage.getItem(
      storage.KEYS.backendCurrentPanel,
    )
    this.updateAccount(account || null)
    this.updateCurrentPanel(currentPanel || null)
  }

  @observable
  isPresentSong = false

  @observable
  account: IAccount | null = null

  @observable
  catalogue: ICatalogueItem[] | null = null

  @observable
  currentCatalogue: ICatalogueItem | null = null

  @observable
  currentCatalogueList: any[] = []

  @observable
  limitedTimeModalVisible = false

  @observable
  limitedTimeModalIsAll = false

  @observable
  changeRoomModalVisible = false

  @observable
  changeTableModalVisible = false

  @observable
  moreOperationModalVisible = false

  @observable
  currentPanel: IPanel = {}

  @observable
  broadcastModalVisible = false

  @observable
  messageModalVisible = false

  @observable
  currentTabParams: any = null

  @observable
  deviceStatus: any = null

  @action
  updateBroadcastModalVisible(val: boolean) {
    this.broadcastModalVisible = val
  }

  @action
  updateMessageModalVisible(val: boolean) {
    this.messageModalVisible = val
  }

  @action
  updateIsPresentSong(val: boolean) {
    this.isPresentSong = val
  }

  @action
  updateCatalogue(val: Record<string, string>) {
    this.catalogue = [
      {
        type: 'hall',
        name: 'hall',
        sn: val.HallId,
      },
      {
        type: 'ppc',
        name: 'ppc',
        sn: val.HallId,
      },
      {
        type: 'front',
        name: 'front',
        sn: val.FrontId,
      },
    ]
  }

  @action
  updateAccount(val: IAccount | null) {
    this.account = val
    storage.setItem(storage.KEYS.backendAccount, val)
  }

  @action
  updateCurrentCatalogue(val: ICatalogueItem | null) {
    this.currentCatalogue = val
  }

  @action
  updateLimitedTimeModalVisible(val: boolean, isAll = false) {
    this.limitedTimeModalVisible = val
    this.limitedTimeModalIsAll = isAll
  }

  @action
  updateCurrentPanel(val: any) {
    this.currentPanel = val
    storage.setItem(storage.KEYS.backendCurrentPanel, val)
  }

  @action
  updateChangeRoomModalVisible(val: boolean) {
    this.changeRoomModalVisible = val
  }

  @action
  updateCurrentCatalogueList(val: any[], currentTabParams: any) {
    // MQTT 模式后，不再由前端更新数据，服务端返回整体数据，所以不用合并更新了。
    // if (this.currentTabParams === currentTabParams) {
    //   this.currentCatalogueList = this.currentCatalogueList.map((item: any) => {
    //     const index = val.findIndex(
    //       (sourceItem: any) => sourceItem.sn === item.sn,
    //     )
    //     if (index !== -1) {
    //       return val[index]
    //     }
    //     return item
    //   })
    // } else {
    //   this.currentCatalogueList = val
    // }
    this.currentCatalogueList = val
    this.currentTabParams = currentTabParams
  }

  @action
  updateChangeTableModalVisible(val: boolean) {
    this.changeTableModalVisible = val
  }

  @action
  updateMoreOperationModalVisible(val: boolean) {
    this.moreOperationModalVisible = val
  }

  @action
  updateDeviceStatus(val: any) {
    this.deviceStatus = val
  }
}

export default BackendStore
